import React, { useEffect, useState, lazy, Suspense } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root'
import { Provider, useSelector } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import { client } from './ApolloClient/client'
import { ApolloProvider } from '@apollo/client'
import { i18nextConfig } from './translations/i18nextConfig'

import store from './redux/store'
import Admin from './routes/admin'
import Auth from './routes/auth'
import Reservation from './routes/reservation'
import ReservationPortal from './routes/customer'
// import Car from './routes/car'
import './static/css/style.css'
import config from './config/config'
import { jeZPlochy } from './mobil/jeTelefon'
import NacitanieMobilu from './mobil/nacitanie'
import Prihlasenie from './mobil/prihlasenie'

// Mobilna verzia sa stahuje az ked na nu niekto pride. Na pocitaci sa
// tento kod nikdy nestiahne a desktopova administracia tym nezmohutnie.
const Mobil = lazy(() => import('./mobil'))
// import ProtectedRoute from './components/utilities/protectedRoute'

const { theme } = config

// init translations
const i18n = i18nextConfig

const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.login
    }
  })

  const [path, setPath] = useState(window.location.pathname)

  useEffect(() => {
    let unmounted = false
    if (!unmounted) {
      setPath(window.location.pathname)
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true)
  }, [setPath])

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode, i18n }}>
        <Router basename={process.env.PUBLIC_URL}>
          {/* {!isLoggedIn ? (
            <Route path='/admin' component={Auth} />
          ) : (
            <ProtectedRoute path='/admin' component={Admin} />
          )} */}

          {isLoggedIn &&
            (path === process.env.PUBLIC_URL ||
              path === `${process.env.PUBLIC_URL}/`) && (
              <Redirect to='/admin' />
            )}
          {!isLoggedIn && <Route path='/admin' component={Auth} />}
          {/* Ked aplikaciu spusti z ikony na ploche neprihlaseny clovek,
              musi dostat prihlasenie, nie prazdnu obrazovku.

              Desktopovy Auth sem NEPATRI: jeho vnutorny Switch pozna iba
              trasy pod /admin, takze na /mobil/kalendar vykreslil obal
              prihlasovacej stranky a v nom nic. Navonok to vyzeralo ako
              rozbita stranka. Mobil ma preto vlastne prihlasenie. */}
          {!isLoggedIn && <Route path='/mobil' component={Prihlasenie} />}
          {isLoggedIn && (
            <>
              <Route path='/reservation' component={Reservation} />

              <Route path='/admin' component={Admin} />

              <Route
                path='/mobil'
                render={() => (
                  <NacitanieMobilu>
                    <Suspense fallback={null}>
                      <Mobil />
                    </Suspense>
                  </NacitanieMobilu>
                )}
              />

              {/* Z ikony na ploche sa otvara /mobil. Keby si clovek na
                  telefone ulozil odkaz na /admin, cela desktopova
                  administracia by sa mu otvorila v celoobrazovkovom okne
                  bez adresneho riadka a nemal by sa ako vratit. */}
              {jeZPlochy() && path.startsWith('/admin') && (
                <Redirect to='/mobil' />
              )}
            </>
          )}

          {(path === process.env.PUBLIC_URL ||
            path === `${process.env.PUBLIC_URL}/`) && (
            // <Redirect to="/admin" />
            // <Route path="/" component={Reservation} />
            <Route path='/' component={ReservationPortal} />
          )}

          {/* <Redirect to="/admin" /> */}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  )
}

function App () {
  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <ProviderConfig />
      </ApolloProvider>
    </Provider>
  )
}

export default hot(App)
